const KEYS = {
  userID: 'session.userID',
  authkey: 'session.authkey',
  state: 'state',
}

export const resetSession = () => {
  localStorage.removeItem(KEYS.userID);
  localStorage.removeItem(KEYS.authkey);
  localStorage.removeItem(KEYS.state);
}

export const getSession = () => {
  const userID = parseInt(localStorage.getItem(KEYS.userID));
  const authkey = localStorage.getItem(KEYS.authkey);
  if (!Number.isNaN(userID) && authkey !== null) {
    return { userID, authkey };
  }

  resetSession();
  return null;
}

export const storeSession = (userID, authkey) => {
  localStorage.setItem(KEYS.userID, userID.toString());
  localStorage.setItem(KEYS.authkey, authkey);
}

export const getState = () => {
  const v = localStorage.getItem(KEYS.state);
  if (v === null) {
    return null;
  }
  return JSON.parse(v);
}

export const storeState = (state) => {
  localStorage.setItem(KEYS.state, JSON.stringify(state));
}
